import React from "react";
import { IQuestionControlProps } from "shared/containers";

export const LikertControl: React.FC<IQuestionControlProps> = (props) => {
	return <div></div>;
};
